import React from "react";
import StateItem from "./StateItem";
import { LocationIcon, ServerIcon, UserIcon } from "../../../../assets/icons";

export default function StateOverview() {
  const stateData = [
    { value: "1 Million+", label: "Users", icon: <UserIcon /> },

    { value: "30+", label: "Locations", icon: <LocationIcon /> },

    { value: "50+", label: "Servers", icon: <ServerIcon /> },
  ];

  return (
    <>
      <div className="divide-x-none mt-6 grid grid-cols-3 divide-[#00000022] rounded-2xl bg-[#F7F7F8] py-3 md:mt-10 md:divide-x md:py-4 2xl:mt-12 2xl:py-5">
        {stateData.map((item, index) => (
          <StateItem
            key={index}
            icon={item.icon}
            value={item.value}
            label={item.label}
          />
        ))}
      </div>
      <div id="feature"></div>
    </>
  );
}
